import React from "react";

import Button from "../../Utils/Button/index.jsx";
import Connector from "../index.jsx";

import {useTranslation} from "react-i18next";

import './styles.scss'

const ConnectorPopUp = ({connectors, openGoogleMaps, setChargePointId, lat, lng}) =>{

    const {t} = useTranslation()


    return <div className="connector_map" >
            <div className="connector_map__buttons">
                <Button className="button_charlie" iconName="pin" onClick={()=>{openGoogleMaps(lat,lng)}}>{t('open_map')}</Button>
                <Button className="button__bravo--invert" iconName="close" onClick={()=>{setChargePointId(null)}}/>
            </div>
            <div className="connector_map__container">
                {connectors.length > 0 ? (
                    connectors.map((connector, idx) => (
                        <Connector key={idx} connector={connector} />
                    ))
                ) : (
                    <p>{t('no_connectors_available')}</p>
                )}
            </div>
        </div>
}
export default ConnectorPopUp